import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username, password, admin, enabled) {
  return yield oncallFetch("/api/oncall/administration/users/add", {
    username,
    password,
    admin,
    enabled,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/users/add.js